import React from 'react';
import loadable from '@loadable/component';

import Loading from '../core/components/Loading';

const View = loadable(() => import(/* webpackChunkName: topup-bitcoin */ './View'), {
  fallback: <Loading />,
});
export default View;
